/* eslint-disable react/button-has-type */
import React from 'react';
import s from './LoadMoreButton.scss';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {withGlobals} from '../../../../globalPropsContext';
import {IGalleryGlobalProps} from '../../../galleryGlobalStrategy';
import classNames from 'classnames';
import {Experiments} from '../../../../constants';

interface LoadMoreButtonProps {
  onClick: any;
  isLoadNext: boolean;
}

class LoadMoreButtonComp extends React.Component<
  LoadMoreButtonProps & IGalleryGlobalProps & IProvidedTranslationProps
> {
  public render() {
    const {isLoadNext, globals} = this.props;
    const {useExperiments} = globals;
    const isLoadMoreButtonEnabled = useExperiments.enabled(Experiments.GalleryEnableLoadMoreHoverUnderlinePetri);
    return (
      <button
        data-hook={isLoadNext ? 'load-more-button' : 'load-previous-button'}
        className={classNames(s.loadMore, {
          [s.loadMoreHoverStyle]: isLoadMoreButtonEnabled,
          [s.loadMoreOldHoverStyle]: !isLoadMoreButtonEnabled,
        })}
        onClick={this.props.onClick}>
        {isLoadNext ? this.props.t('loadMoreButtonText') : this.props.t('loadPreviousButtonText')}
      </button>
    );
  }
}

export const LoadMoreButton = withGlobals(withTranslations()(LoadMoreButtonComp));
